var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-footer',{staticClass:"pa-4 base-footer",class:_vm.classFooter,attrs:{"app":"","inset":"","fixed":""}},[_c('div',{class:_vm.limit},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }